var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45449 7.18555C8.0654 7.44953 7.53152 7.40914 7.18675 7.06437L4.35832 4.23594C3.9678 3.84542 3.9678 3.21225 4.35832 2.82173C4.74885 2.4312 5.38201 2.4312 5.77254 2.82173L7.89386 4.94305L10.0152 2.8217C10.4057 2.43118 11.0389 2.43118 11.4294 2.8217C11.8199 3.21223 11.8199 3.84539 11.4294 4.23592L8.601 7.06434C8.59612 7.06922 8.59121 7.07403 8.58627 7.07878C8.54475 7.11865 8.50064 7.15424 8.45449 7.18555Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrow-down-icon.218e1d1c6b41b624d62a921816d3c47c.svg";
export { ForwardRef as ReactComponent };